import React from "react";
import Select from "react-select";
import "./FontWeightPicker.css";
import {
  Row,
  Col,
  Label
} from "reactstrap";

import SystemLabel from "../../system/SystemLabel/SystemLabel";

const fontWeights = [
  { value: "lighter", label: "Lighter" },
  { value: "normal", label: "Normal" },
  { value: "bold", label: "Bold" },
  { value: "bolder", label: "Bolder" }
];

export const FontWeightPicker = ({ weight, onChange, currentFont, path }) => {
  const optionStyle = {
    option: (styles, { data }) => {
      return {
        ...styles,
        fontSize: '12px',
        fontFamily: currentFont,
        fontWeight: data.value,
        padding: "0 10px"
      };
    },
    container: styles => ({
      ...styles,
      minWidth: "100%"
    }),
    singleValue: (styles, { data }) => {
      return {
        ...styles,
        fontSize: '12px',
        fontWeight: weight,
        fontFamily: currentFont
      };
    }
  };

  return (
    <React.Fragment>
      <Row >
        <Col className="list-setting-item-title">
          <Label>
            <SystemLabel name="FontWeight" />
          </Label>
        </Col>
        <Col className="list-setting-item-item">
          <Select
            className="jirango-weightpicker"
            classNamePrefix="jirango-weightpicker"
            options={fontWeights}
            value={{
              value: weight !== undefined ? weight : 'unset',
              label: weight !== undefined ? weight.charAt(0).toUpperCase() + weight.slice(1) : 'Unset'
            }}
            onChange={selectedOption =>
              onChange(null, selectedOption.value, path)
            }
            styles={optionStyle}
          />
        </Col>
      </Row>
    </React.Fragment>
  );
};
